import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "gene-expression-container" }
const _hoisted_2 = { class: "left-side" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "sub-title" }, "Exploration", -1)
const _hoisted_4 = { class: "select-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, " Genes/Features ", -1)
const _hoisted_6 = {
  key: 0,
  class: "select-container"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, " Spatially Variable Genes ", -1)
const _hoisted_8 = { class: "switch-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "switch-label" }, "Log", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "sub-title" }, "Style", -1)
const _hoisted_11 = { class: "select-container" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, " Marker Size ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "sub-title" }, "Custom Color Range", -1)
const _hoisted_14 = { class: "input-container" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "input-lable" }, "Min", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "input-lable" }, "Max", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Confirm ")
const _hoisted_18 = { class: "switch-container" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "switch-label" }, "Reverse Colors", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", { class: "sub-title" }, "Selection", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "sub-title" }, "Custom Expression Range", -1)
const _hoisted_22 = { class: "input-container" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "input-lable" }, "Min", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "input-lable" }, "Max", -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Confirm ")
const _hoisted_26 = { class: "switch-container" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "switch-label" }, "Median", -1)
const _hoisted_28 = { class: "switch-container" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "switch-label" }, "Reverse", -1)
const _hoisted_30 = { class: "right-side" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_GeneExpressionScatterPlot = _resolveComponent("GeneExpressionScatterPlot")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_select_v2, {
          modelValue: _ctx.selectedGeneFeature,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGeneFeature) = $event)),
          class: "select",
          filterable: "",
          remote: "",
          "remote-method": _ctx.geneFeatureFilter,
          options: _ctx.geneFeatureList,
          onChange: _ctx.geneFeatureChangeCallBack
        }, null, 8, ["modelValue", "remote-method", "options", "onChange"])
      ]),
      (_ctx.moranIShow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_el_select_v2, {
              modelValue: _ctx.selectedGeneFeature,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedGeneFeature) = $event)),
              class: "select",
              filterable: "",
              remote: "",
              "remote-method": _ctx.geneFeatureFilter,
              options: _ctx.geneFeatureMoranIList,
              onChange: _ctx.geneFeatureChangeCallBack
            }, null, 8, ["modelValue", "remote-method", "options", "onChange"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_switch, {
          modelValue: _ctx.useLog,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.useLog) = $event)),
          disabled: !_ctx.logable,
          onChange: _ctx.logChangeCallBack
        }, null, 8, ["modelValue", "disabled", "onChange"]),
        _hoisted_9
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_el_select, {
          modelValue: _ctx.markerSize,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.markerSize) = $event)),
          class: "select",
          filterable: "",
          onChange: _ctx.markerSizeChangeCallback
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markerSizeList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item,
                label: String(item),
                value: item
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_el_input_number, {
          modelValue: _ctx.colorSetMin,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.colorSetMin) = $event)),
          min: _ctx.useLog ? Math.log(1 + _ctx.expressionMin) : _ctx.expressionMin,
          max: _ctx.useLog ? Math.log(1 + _ctx.expressionMax) : _ctx.expressionMax,
          controls: false,
          size: "small",
          class: "input-item"
        }, null, 8, ["modelValue", "min", "max"]),
        _hoisted_16,
        _createVNode(_component_el_input_number, {
          modelValue: _ctx.colorSetMax,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.colorSetMax) = $event)),
          min: _ctx.useLog ? Math.log(1 + _ctx.expressionMin) : _ctx.expressionMin,
          max: _ctx.useLog ? Math.log(1 + _ctx.expressionMax) : _ctx.expressionMax,
          controls: false,
          label: "Max",
          size: "small",
          class: "input-item"
        }, null, 8, ["modelValue", "min", "max"]),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: _ctx.setColorMinMax
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_el_switch, {
          modelValue: _ctx.reverseColor,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.reverseColor) = $event)),
          onChange: _ctx.reverseColorChangeCallBack
        }, null, 8, ["modelValue", "onChange"]),
        _hoisted_19
      ]),
      _hoisted_20,
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createVNode(_component_el_input_number, {
          modelValue: _ctx.expressionSetMin,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.expressionSetMin) = $event)),
          min: _ctx.useLog ? Math.log(1 + _ctx.expressionMin) : _ctx.expressionMin,
          max: _ctx.useLog ? Math.log(1 + _ctx.expressionMax) : _ctx.expressionMax,
          controls: false,
          size: "small",
          class: "input-item"
        }, null, 8, ["modelValue", "min", "max"]),
        _hoisted_24,
        _createVNode(_component_el_input_number, {
          modelValue: _ctx.expressionSetMax,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.expressionSetMax) = $event)),
          min: _ctx.useLog ? Math.log(1 + _ctx.expressionMin) : _ctx.expressionMin,
          max: _ctx.useLog ? Math.log(1 + _ctx.expressionMax) : _ctx.expressionMax,
          controls: false,
          label: "Max",
          size: "small",
          class: "input-item"
        }, null, 8, ["modelValue", "min", "max"]),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: _ctx.setSelectMinMax
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_el_switch, {
          modelValue: _ctx.useMedian,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.useMedian) = $event)),
          onChange: _ctx.setMedian
        }, null, 8, ["modelValue", "onChange"]),
        _hoisted_27
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_el_switch, {
          modelValue: _ctx.reverseSelect,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.reverseSelect) = $event)),
          onChange: _ctx.reverseSelectChangeCallBack
        }, null, 8, ["modelValue", "onChange"]),
        _hoisted_29
      ])
    ]),
    _createVNode(_component_el_divider, {
      direction: "vertical",
      class: "mid-separator"
    }),
    _createElementVNode("div", _hoisted_30, [
      _createVNode(_component_GeneExpressionScatterPlot, { ref: "expressionPlot" }, null, 512)
    ])
  ]))
}